export default __webpack_public_path__ + "static/Executive Coach - Angela Cooney - EMCC -accredited coach-ff5b245cec4100cf4b436898476eb5b3.svg";